import { render } from "./TMC.vue?vue&type=template&id=aa27ee28&scoped=true"
import script from "./TMC.vue?vue&type=script&lang=js"
export * from "./TMC.vue?vue&type=script&lang=js"

import "./TMC.vue?vue&type=style&index=0&id=aa27ee28&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa27ee28"]])

export default __exports__